<template>

    <div class="signup-page">
        <Header></Header>
        <section class="signup-section">
            <div class="container">
                <div class="row">
                    <div class="col-md-5" style="margin: 0 auto;">
                        <h2>Create Video</h2>
                        <VideoUpload :campaignId="campaignId" admin="true" />
                    </div>
                </div>
            </div>
        </section>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '../Header'
    import Footer from '../Footer'
    import VideoUpload from '../../include/videoUpload'
    import router from '../../../router'
    export default {
        name: 'AdminSixftapartCreate',
        components: {
            'Header': Header,
            'Footer': Footer,
            'VideoUpload': VideoUpload
        },
        data() {
            return {
                campaignId: router.history.current.params.id,
                msg: 'Welcome to Your Vue.js App'
            }
        },
        methods: {}
    }
</script>



// WEBPACK FOOTER //
// src/components/admin/6ftapart/Create.vue